module.exports = __webpack_public_path__ + "img/home-6.29092d3d.webp";